var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-app',[_c('md-app-toolbar',{staticClass:"md-layout md-alignment-center"},[_c('img',{staticClass:"logo",attrs:{"src":"/logo.png","alt":"Lay Up logo"}})]),_c('md-app-content',{staticClass:"md-layout md-alignment-center no-auth"},[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }